import { useState } from 'react'
import { CreateAccountModal } from './CreateAccountModal'
import { SignInModal } from './SignInModal'

export function CTA() {
  const [showCreateAccount, setShowCreateAccount] = useState(false)
  const [showSignIn, setShowSignIn] = useState(false)

  const switchToSignIn = () => { setShowCreateAccount(false); setShowSignIn(true) }
  const switchToCreateAccount = () => { setShowSignIn(false); setShowCreateAccount(true) }

  return (
    <section className="img-get-strt relative py-8 md:py-32 bg-cover bg-center overflow-hidden" style={{
      backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0.4), rgba(0,0,0,0.3)), url("/images/cta.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      minHeight: '584px',
      display: 'flex',
      alignItems: 'center',
    }}>
      <div className="max-w-4xl mx-auto text-center px-4 relative z-10 w-full">
        <h2 className="common-size40 text-[40px] text-white font-bold mb-6 leading-tight">
          GET STARTED
        </h2>
        <p className="get-strt common-size16 text-white text-base md:text-lg mb-10 leading-relaxed font-light max-w-2xl mx-auto">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do<br/> eiusmod tempor. Incididunt ut labore et dolore magna aliqua. Ut<br/> enim ad minim veniam, quis nostrud exercitation ullamco.
        </p>

        <button
          type="button"
          onClick={() => setShowCreateAccount(true)}
          className="get-strt-btn inline-block bg-white text-[#4D4D4D] px-8 py-5 rounded-2xl font-semibold text-lg hover:bg-gray-100 transition"
        >
          CREATE FREE ACCOUNT
        </button>
      </div>

      <CreateAccountModal
        isOpen={showCreateAccount}
        onClose={() => setShowCreateAccount(false)}
        onSwitchToSignIn={switchToSignIn}
      />
      <SignInModal
        isOpen={showSignIn}
        onClose={() => setShowSignIn(false)}
        onSwitchToCreateAccount={switchToCreateAccount}
      />
    </section>
  )
}
